module.exports = __webpack_public_path__ + "img/新河钻机.537d9042.jpg";